export default __webpack_public_path__ + "static/media/checkmark.a7026474.png";